import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {PrlLabelService} from '../services/prl-label.service';
import {Observable} from 'rxjs';
import {PrlLanguageService} from '../../../prl-language/services/prl-language.service';

@Component({
    selector: 'prl-info',
    templateUrl: './info.component.html',
    standalone: false,
    styleUrls: ['./info.component.scss']
})

export class InfoComponent implements OnInit {

    infoContent: Observable<string>;
    safeHtml: SafeHtml;
    currentLanguage: string;

    constructor(private sanitizer: DomSanitizer,
                private prlLabelService: PrlLabelService,
                private prlLanguageService: PrlLanguageService) {
    }

    ngOnInit(): void {
        this.assignContent()
    }

    assignContent(): void {
        this.prlLanguageService.language.subscribe(
            lang => { this.currentLanguage = lang;
                this.infoContent = this.prlLabelService.getLabelContent('label.info.content', this.currentLanguage);
                this.infoContent.subscribe(content => {
                    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(content);
                });
            });
    }
}
